module.exports = __webpack_public_path__ + "img/cf.2d551ba5.svg";